import { render, staticRenderFns } from "./MedicineAbout.vue?vue&type=template&id=62eb74cc"
import script from "./MedicineAbout.vue?vue&type=script&lang=js"
export * from "./MedicineAbout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports